import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {RootState} from '..';
import {IArtifact} from 'app/types/Shared';
import {artifactsApi} from './artifactsApi';

export interface IArtifactState {
  allArtifacts: Array<IArtifact>;
  masterSOP?: IArtifact;
}

export const initialState: IArtifactState = {
  allArtifacts: [],
  masterSOP: undefined,
};

export const artifactSlice = createSlice({
  name: 'artifacts',
  initialState,
  reducers: {
    setAllArtifacts: (state, {payload}: PayloadAction<Array<IArtifact>>) => {
      state.allArtifacts = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(artifactsApi.endpoints.getAllArtifacts.matchFulfilled, (state, {payload}) => {
      state.allArtifacts = payload;
    });
    builder.addMatcher(artifactsApi.endpoints.getMasterSOP.matchFulfilled, (state, {payload}) => {
      state.masterSOP = payload;
    });
  },
});

export const selectAllArtifacts = (state: RootState) => state.artifacts.allArtifacts;
export const selectMasterSOP = (state: RootState) => state.artifacts.masterSOP;
export default artifactSlice.reducer;
